import { FormControlLabel, Switch, Typography } from '@mui/material'
import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form'
import type { BooleanField } from '../../types'

interface BooleanFeatureInputFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  field: BooleanField
  label: string
}

export const BooleanInputField = <T extends FieldValues>({ field, label, ...props }: BooleanFeatureInputFieldProps<T>) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={(form) => (
        <FormControlLabel
          {...props}
          onChange={(_, checked) => form.field.onChange(checked as PathValue<T, Path<T>>)}
          sx={{ margin: 0, alignItems: 'baseline' }}
          labelPlacement="top"
          control={
            <Switch
              id={`boolean-switch-${field.name}`}
              role="switch"
              name={field.name}
              checked={form.field.value}
              value={form.field.value}
            />
          }
          label={
            <Typography variant="p4Regular" color="textSecondary">
              {label}
            </Typography>
          }
        />
      )}
    />
  )
}
